import { SearchProject, StyledSearchIcon } from "@/components/styled";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "antd";
import { bool } from "prop-types";
import { useIntl } from "react-intl";

export const SearchFilterButton = ({ isActive, isUserFilter }) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={intl.formatMessage({
        id: isUserFilter
          ? "tableFilters.userFilterTooltip"
          : "tableFilters.searchFilterTooltip",
      })}
    >
      <SearchProject>
        <StyledSearchIcon
          icon={faSearch}
          $active={isActive}
        />
      </SearchProject>
    </Tooltip>
  );
};

SearchFilterButton.propTypes = {
  isActive: bool,
  isUserFilter: bool,
};
